import{a as t}from"./chunk-RAAYCPUM.js";function a(...n){return t(i,n)}function i(n){let e=typeof n[0]=="bigint"?0n:0;for(let r of n)e+=r;return e}export{a};
